import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import { utils, Transform, Rectangle, RAD_TO_DEG, DEG_TO_RAD } from '@pixi/core';
import { Bounds } from './Bounds.mjs';
var DisplayObject = /*#__PURE__*/function (_utils$EventEmitter) {
  _inherits(DisplayObject, _utils$EventEmitter);
  var _super = _createSuper(DisplayObject);
  function DisplayObject() {
    var _this;
    _classCallCheck(this, DisplayObject);
    _this = _super.call(this);
    _this.tempDisplayObjectParent = null;
    _this.transform = new Transform();
    _this.alpha = 1;
    _this.visible = true;
    _this.renderable = true;
    _this.cullable = false;
    _this.cullArea = null;
    _this.parent = null;
    _this.worldAlpha = 1;
    _this._lastSortedIndex = 0;
    _this._zIndex = 0;
    _this.filterArea = null;
    _this.filters = null;
    _this._enabledFilters = null;
    _this._bounds = new Bounds();
    _this._localBounds = null;
    _this._boundsID = 0;
    _this._boundsRect = null;
    _this._localBoundsRect = null;
    _this._mask = null;
    _this._maskRefCount = 0;
    _this._destroyed = false;
    _this.isSprite = false;
    _this.isMask = false;
    return _this;
  }
  _createClass(DisplayObject, [{
    key: "destroyed",
    get: function get() {
      return this._destroyed;
    }
  }, {
    key: "_recursivePostUpdateTransform",
    value: function _recursivePostUpdateTransform() {
      if (this.parent) {
        this.parent._recursivePostUpdateTransform();
        this.transform.updateTransform(this.parent.transform);
      } else {
        this.transform.updateTransform(this._tempDisplayObjectParent.transform);
      }
    }
  }, {
    key: "updateTransform",
    value: function updateTransform() {
      this._boundsID++;
      this.transform.updateTransform(this.parent.transform);
      this.worldAlpha = this.alpha * this.parent.worldAlpha;
    }
  }, {
    key: "getBounds",
    value: function getBounds(skipUpdate, rect) {
      if (!skipUpdate) {
        if (!this.parent) {
          this.parent = this._tempDisplayObjectParent;
          this.updateTransform();
          this.parent = null;
        } else {
          this._recursivePostUpdateTransform();
          this.updateTransform();
        }
      }
      if (this._bounds.updateID !== this._boundsID) {
        this.calculateBounds();
        this._bounds.updateID = this._boundsID;
      }
      if (!rect) {
        if (!this._boundsRect) {
          this._boundsRect = new Rectangle();
        }
        rect = this._boundsRect;
      }
      return this._bounds.getRectangle(rect);
    }
  }, {
    key: "getLocalBounds",
    value: function getLocalBounds(rect) {
      if (!rect) {
        if (!this._localBoundsRect) {
          this._localBoundsRect = new Rectangle();
        }
        rect = this._localBoundsRect;
      }
      if (!this._localBounds) {
        this._localBounds = new Bounds();
      }
      var transformRef = this.transform;
      var parentRef = this.parent;
      this.parent = null;
      this.transform = this._tempDisplayObjectParent.transform;
      var worldBounds = this._bounds;
      var worldBoundsID = this._boundsID;
      this._bounds = this._localBounds;
      var bounds = this.getBounds(false, rect);
      this.parent = parentRef;
      this.transform = transformRef;
      this._bounds = worldBounds;
      this._bounds.updateID += this._boundsID - worldBoundsID;
      return bounds;
    }
  }, {
    key: "toGlobal",
    value: function toGlobal(position, point) {
      var skipUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      if (!skipUpdate) {
        this._recursivePostUpdateTransform();
        if (!this.parent) {
          this.parent = this._tempDisplayObjectParent;
          this.displayObjectUpdateTransform();
          this.parent = null;
        } else {
          this.displayObjectUpdateTransform();
        }
      }
      return this.worldTransform.apply(position, point);
    }
  }, {
    key: "toLocal",
    value: function toLocal(position, from, point, skipUpdate) {
      if (from) {
        position = from.toGlobal(position, point, skipUpdate);
      }
      if (!skipUpdate) {
        this._recursivePostUpdateTransform();
        if (!this.parent) {
          this.parent = this._tempDisplayObjectParent;
          this.displayObjectUpdateTransform();
          this.parent = null;
        } else {
          this.displayObjectUpdateTransform();
        }
      }
      return this.worldTransform.applyInverse(position, point);
    }
  }, {
    key: "setParent",
    value: function setParent(container) {
      if (!container || !container.addChild) {
        throw new Error("setParent: Argument must be a Container");
      }
      container.addChild(this);
      return container;
    }
  }, {
    key: "removeFromParent",
    value: function removeFromParent() {
      var _this$parent;
      (_this$parent = this.parent) === null || _this$parent === void 0 ? void 0 : _this$parent.removeChild(this);
    }
  }, {
    key: "setTransform",
    value: function setTransform() {
      var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var scaleX = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
      var scaleY = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;
      var rotation = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var skewX = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      var skewY = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 0;
      var pivotX = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 0;
      var pivotY = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : 0;
      this.position.x = x;
      this.position.y = y;
      this.scale.x = !scaleX ? 1 : scaleX;
      this.scale.y = !scaleY ? 1 : scaleY;
      this.rotation = rotation;
      this.skew.x = skewX;
      this.skew.y = skewY;
      this.pivot.x = pivotX;
      this.pivot.y = pivotY;
      return this;
    }
  }, {
    key: "destroy",
    value: function destroy(_options) {
      this.removeFromParent();
      this._destroyed = true;
      this.transform = null;
      this.parent = null;
      this._bounds = null;
      this.mask = null;
      this.cullArea = null;
      this.filters = null;
      this.filterArea = null;
      this.hitArea = null;
      this.interactive = false;
      this.interactiveChildren = false;
      this.emit("destroyed");
      this.removeAllListeners();
    }
  }, {
    key: "_tempDisplayObjectParent",
    get: function get() {
      if (this.tempDisplayObjectParent === null) {
        this.tempDisplayObjectParent = new TemporaryDisplayObject();
      }
      return this.tempDisplayObjectParent;
    }
  }, {
    key: "enableTempParent",
    value: function enableTempParent() {
      var myParent = this.parent;
      this.parent = this._tempDisplayObjectParent;
      return myParent;
    }
  }, {
    key: "disableTempParent",
    value: function disableTempParent(cacheParent) {
      this.parent = cacheParent;
    }
  }, {
    key: "x",
    get: function get() {
      return this.position.x;
    },
    set: function set(value) {
      this.transform.position.x = value;
    }
  }, {
    key: "y",
    get: function get() {
      return this.position.y;
    },
    set: function set(value) {
      this.transform.position.y = value;
    }
  }, {
    key: "worldTransform",
    get: function get() {
      return this.transform.worldTransform;
    }
  }, {
    key: "localTransform",
    get: function get() {
      return this.transform.localTransform;
    }
  }, {
    key: "position",
    get: function get() {
      return this.transform.position;
    },
    set: function set(value) {
      this.transform.position.copyFrom(value);
    }
  }, {
    key: "scale",
    get: function get() {
      return this.transform.scale;
    },
    set: function set(value) {
      this.transform.scale.copyFrom(value);
    }
  }, {
    key: "pivot",
    get: function get() {
      return this.transform.pivot;
    },
    set: function set(value) {
      this.transform.pivot.copyFrom(value);
    }
  }, {
    key: "skew",
    get: function get() {
      return this.transform.skew;
    },
    set: function set(value) {
      this.transform.skew.copyFrom(value);
    }
  }, {
    key: "rotation",
    get: function get() {
      return this.transform.rotation;
    },
    set: function set(value) {
      this.transform.rotation = value;
    }
  }, {
    key: "angle",
    get: function get() {
      return this.transform.rotation * RAD_TO_DEG;
    },
    set: function set(value) {
      this.transform.rotation = value * DEG_TO_RAD;
    }
  }, {
    key: "zIndex",
    get: function get() {
      return this._zIndex;
    },
    set: function set(value) {
      this._zIndex = value;
      if (this.parent) {
        this.parent.sortDirty = true;
      }
    }
  }, {
    key: "worldVisible",
    get: function get() {
      var item = this;
      do {
        if (!item.visible) {
          return false;
        }
        item = item.parent;
      } while (item);
      return true;
    }
  }, {
    key: "mask",
    get: function get() {
      return this._mask;
    },
    set: function set(value) {
      if (this._mask === value) {
        return;
      }
      if (this._mask) {
        var maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
        if (maskObject) {
          maskObject._maskRefCount--;
          if (maskObject._maskRefCount === 0) {
            maskObject.renderable = true;
            maskObject.isMask = false;
          }
        }
      }
      this._mask = value;
      if (this._mask) {
        var _maskObject = this._mask.isMaskData ? this._mask.maskObject : this._mask;
        if (_maskObject) {
          if (_maskObject._maskRefCount === 0) {
            _maskObject.renderable = false;
            _maskObject.isMask = true;
          }
          _maskObject._maskRefCount++;
        }
      }
    }
  }], [{
    key: "mixin",
    value: function mixin(source) {
      var keys = Object.keys(source);
      for (var i = 0; i < keys.length; ++i) {
        var propertyName = keys[i];
        Object.defineProperty(DisplayObject.prototype, propertyName, Object.getOwnPropertyDescriptor(source, propertyName));
      }
    }
  }]);
  return DisplayObject;
}(utils.EventEmitter);
var TemporaryDisplayObject = /*#__PURE__*/function (_DisplayObject) {
  _inherits(TemporaryDisplayObject, _DisplayObject);
  var _super2 = _createSuper(TemporaryDisplayObject);
  function TemporaryDisplayObject() {
    var _this2;
    _classCallCheck(this, TemporaryDisplayObject);
    _this2 = _super2.apply(this, arguments);
    _this2.sortDirty = null;
    return _this2;
  }
  return _createClass(TemporaryDisplayObject);
}(DisplayObject);
DisplayObject.prototype.displayObjectUpdateTransform = DisplayObject.prototype.updateTransform;
export { DisplayObject, TemporaryDisplayObject };